export const environment = {
    APP_URL: 'https://futurevisioniasacademy.com',
    FILE_URL: 'https://futurevisioniasacademy.com',
    // APP_URL: 'http://localhost:7723'
  };
